import { NodeId } from 'src/app/directives/if-node-directive/if-node-hide.directive';
import { Constants } from 'src/app/models/constants';

export type NumberSeparator = '.' | ',';

export interface RegionNumberFormat {
  // Angular LOCALE_ID; it also drives DatePipe, so changing it affects dates
  locale: string;
  decimal: NumberSeparator;
  group: NumberSeparator;
  maxInputDecimals: number;
}

export interface RegionNumberFormatRule extends RegionNumberFormat {
  nodes: NodeId[];
}

// Each node must appear in exactly one rule (enforced by region-number-format.config.spec.ts).
export const REGION_NUMBER_FORMATS: RegionNumberFormatRule[] = [
  {
    nodes: [
      Constants.TENANT_ID_AR,
      Constants.TENANT_ID_EC,
      Constants.TENANT_ID_UY,
      Constants.TENANT_ID_PY,
      Constants.TENANT_ID_GLOBAL,
    ],
    locale: 'es-AR',
    decimal: ',',
    group: '.',
    maxInputDecimals: 2,
  },
  {
    nodes: [Constants.TENANT_ID_DO],
    locale: 'es-DO',
    decimal: '.',
    group: ',',
    maxInputDecimals: 2,
  },
];

export const FALLBACK_NUMBER_FORMAT_NODE: NodeId = Constants.TENANT_ID_AR;

export function getRegionNumberFormat(node: string): RegionNumberFormat {
  let rule = findRule(node);
  if (!rule) {
    console.warn(`No number format rule for node "${node}", using "${FALLBACK_NUMBER_FORMAT_NODE}"`);
    rule = findRule(FALLBACK_NUMBER_FORMAT_NODE)!;
  }

  return {
    locale: rule.locale,
    decimal: rule.decimal,
    group: rule.group,
    maxInputDecimals: rule.maxInputDecimals,
  };
}

function findRule(node: string): RegionNumberFormatRule | undefined {
  return REGION_NUMBER_FORMATS.find((rule) => rule.nodes.includes(node as NodeId));
}
